import { render, staticRenderFns } from "./FullResponsePanel.vue?vue&type=template&id=bb97a9a8&scoped=true&"
import script from "./FullResponsePanel.vue?vue&type=script&lang=ts&"
export * from "./FullResponsePanel.vue?vue&type=script&lang=ts&"
import style0 from "./FullResponsePanel.vue?vue&type=style&index=0&id=bb97a9a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb97a9a8",
  null
  
)

export default component.exports